import EventShareHome from '@/screens/EventShareHome';

export default function PrivateEventShareIndexRoute() {
  return <EventShareHome />;
}
